import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const GenerationSettingsPanel = ({ settings, onSettingsChange }) => {
  const frontendOptions = [
    { value: 'react', label: 'React 18', description: 'Modern React with hooks' },
    { value: 'nextjs', label: 'Next.js 14', description: 'React framework with SSR' },
    { value: 'vue', label: 'Vue 3', description: 'Progressive framework' },
    { value: 'angular', label: 'Angular 17', description: 'Full-featured framework' }
  ];

  const backendOptions = [
    { value: 'nodejs', label: 'Node.js + Express', description: 'JavaScript runtime' },
    { value: 'python', label: 'Python + FastAPI', description: 'Modern Python framework' },
    { value: 'java', label: 'Java + Spring Boot', description: 'Enterprise Java' },
    { value: 'go', label: 'Go + Gin', description: 'High-performance Go' }
  ];

  const databaseOptions = [
    { value: 'postgresql', label: 'PostgreSQL', description: 'Relational database' },
    { value: 'mongodb', label: 'MongoDB', description: 'NoSQL document database' },
    { value: 'mysql', label: 'MySQL', description: 'Popular relational DB' },
    { value: 'supabase', label: 'Supabase', description: 'PostgreSQL with auth' }
  ];

  const authOptions = [
    { value: 'jwt', label: 'JWT Authentication', description: 'Token-based auth' },
    { value: 'oauth', label: 'OAuth 2.0', description: 'Third-party auth' },
    { value: 'supabase', label: 'Supabase Auth', description: 'Built-in auth system' },
    { value: 'none', label: 'No Authentication', description: 'Skip auth setup' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-5">
        <Icon name="Settings" size={20} className="text-primary" />
        <h3 className="text-base md:text-lg font-semibold">Generation Settings</h3>
      </div>
      <div className="space-y-4">
        <Select
          label="Frontend Framework"
          description="Choose your preferred frontend technology"
          options={frontendOptions}
          value={settings?.frontend}
          onChange={(value) => onSettingsChange({ ...settings, frontend: value })}
        />

        <Select
          label="Backend Framework"
          description="Select backend technology stack"
          options={backendOptions}
          value={settings?.backend}
          onChange={(value) => onSettingsChange({ ...settings, backend: value })}
        />

        <Select
          label="Database"
          description="Choose your database system"
          options={databaseOptions}
          value={settings?.database}
          onChange={(value) => onSettingsChange({ ...settings, database: value })}
        />

        <Select
          label="Authentication"
          description="Select authentication method"
          options={authOptions}
          value={settings?.auth}
          onChange={(value) => onSettingsChange({ ...settings, auth: value })}
        />
      </div>
      <div className="mt-4 md:mt-5 pt-4 border-t border-border">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
          <p className="text-xs md:text-sm text-muted-foreground">
            These settings will determine the structure and technologies used in your generated project.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GenerationSettingsPanel;